export default {
  apiKey: "AIzaSyDscL6Db_Rnz_c_pwNiFrdGDlO_TuoSQGQ",
  authDomain: "ijsvle.firebaseapp.com",
  databaseURL: "https://ijsvle.firebaseio.com",
  projectId: "ijsvle",
  storageBucket: "ijsvle.appspot.com",
  messagingSenderId: "1034233392159",
  appId: "1:1034233392159:web:e14a2fc2a17f8ba7a3392a",
  measurementId: "G-6REG9Q0808"
}
